module.exports = __webpack_public_path__ + "static/k1Res1-bf9fa338bb0ece9f9b52f0833b9cc5fd.png";